const routes = [
    {
        path: 'nova-solicitacao',
        name: 'NovaSolicitacaoRegra',
        component: () => import('./AdicionarRegra.vue'),
        props: route => ({
            id: route.params.id,
            editando: route.params.editando === true || route.params.editando === 'true', titulo: route.params.titulo
        }),
        meta: {
            rules: [''],
        },
    },
];

export default routes;
